export * from './cookie'
export * from './layout'

export const AUTH_BASE_PATH = 'auth'

/**
 * The backend of the Eight Wave cloud: where a widget with no `base-url`
 * talks, as it always has. A dedicated installation sets `base-url`; nothing
 * else of an installation is built into the bundle (README, "Dedicated
 * installations").
 */
export const DEFAULT_BACKEND_URL = 'https://ai-api.8wave.it'
